<!-- 顶部导航 -->
<template>
  <div style="background-color:#ffff">
    <div class="container-xl menubar" @touchmove.prevent>
      <div class="logo">
        <img @click.stop="toPage(0,-1,0,-1,-1)" src="../assets/img/logo.png">
      </div>
      <ul style="margin:0;padding:0;" v-show="!isSearch">
        <li :class="one=='-1'&&'nav-active'">
          <a @click.stop="toPage(0,-1,0,-1)">
            <span class="title">首页</span>
            <img src="../assets/img/more.png" class="more">
          </a>
        </li>
        <li :class="one==index&&'nav-active'" v-for="(item,index) of tree" :key="index">
          <a @click.stop="toPage(item,index,0,-1,item.subs?item.subs[0].mcode:item.mcode,item.outlink)">
            <span class="title">{{item.name}}</span>
            <img src="../assets/img/more.png" class="more">
          </a>
          <div class="subnav" v-if="item.subs">
            <span v-for="(value,key) of item.subs" :key="key"
              @click.stop="toPage(value,index,key,-1,value.mcode,value.outlink,value.subs)">{{value.name}}</span>
          </div>
        </li>

      </ul>

      <div class="search">
        <div class="box" v-show="isSearch">
          <img src="../assets/img/search.png">
          <input type="text" v-model="keyword" @keyup.enter="tosearch" placeholder="请输入关键词">
        </div>
        <img src="../assets/img/search.png" class="icon0" v-show="!isSearch" @click="isSearch = true">
        <img src="../assets/img/close.png" class="icon0" v-show="isSearch" @click="isSearch = false">
      </div>
      <div id="toggleBar" class="bar"><img src="../assets/img/action.png" alt="" class="nav-logo">
      </div>
    </div>
    <div class="subnav">
      <div class="s" v-if="one==-1">
        <span :class="one=='-1'&&'active'" @click.stop="toPage(0,-1,0,-1,-1)">首页</span>
        <span :class="one==index&&'active'" v-for="(item,index) of tree" :key="index"
          @click.stop="toPage(item,index,0,-1,item.subs?item.subs[0].mcode:item.mcode,item.outlink)">{{item.name}}</span>
      </div>

      <div class="s" v-else-if="one!=-1&&three==-1">
        <span :class="tow==index&&'active'" v-for="(item,index) of tree[one].subs" :key="index"
          @click.stop="toPage(item,one,index,-1,item.mcode,item.outlink,item.subs)">{{item.name}}</span>
      </div>

      <div class="s" v-else>
        <span :class="three==index&&'active'" v-for="(item,index) of towTree.subs" :key="index"
          @click.stop="toPage(item,one,tow,index,item.mcode)">{{item.name}}</span>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      xd_flag: false,
      isSearch: false,
      keyword: "",
    };
  },

  computed: {
    //所有菜单
    tree() {
      return this.$store.state.user.tree;
    },
    //一级菜单
    one() {
      return this.$store.state.user.one;
    },
    oneTree() {
      return this.$store.state.user.oneTree;
    },

    //二级菜单
    tow() {
      return this.$store.state.user.tow;
    },
    towTree() {
      return this.$store.state.user.towTree;
    },

    //三级菜单
    three() {
      return this.$store.state.user.three;
    },
    threeTree() {
      return this.$store.state.user.threeTree;
    },
  },
  created() {
    if (this.$route.query.one) {
      let query = this.$route.query;
      let param = {
        one: query.one,
        tow: query.tow,
        three: query.three,
        mcode: query.mcode,
      };
      this.$store.commit("SET_Menu", param);
      this.$store.commit("SET_scode", query.scode);
    }
  },
  mounted() {
    let toggleBar = document.getElementById("toggleBar");
    let MenubarUl = document.querySelector(".menubar ul");
    let LeftSildeMenubar = document.querySelector(".menubar ul");

    //显示侧滑导航栏
    toggleBar.onclick = function () {
      LeftSildeMenubar.classList.toggle("active");
      document.body.style.overflow = "hidden";
    };

    //隐藏策划导航栏
    MenubarUl.onclick = function () {
      LeftSildeMenubar.classList.remove("active");
      document.body.style.overflow = "scroll";
    };
  },
  methods: {
    //搜索
    tosearch() {
      let vm = this;
      this.$router.push({
        path: "/search",
        query: {
          keyword: vm.keyword,
        },
      });
    },
    //路由跳转
    toPage(item, one, tow, three, mcode, outlink, subs) {
      if (outlink) {
        window.location.href = outlink;
        return;
      }
      // debugger
      let nowMcode = mcode;
      if (subs) {
        nowMcode = subs[0].mcode;
      }

      let param = {
        one,
        tow,
        three: subs ? 0 : three,
        mcode: nowMcode,
      };
      let scode = 0;
      if (item) {
        if (item.subs) {
          scode = item.subs[0].scode;
        } else {
          scode = item.scode;
        }
      }
      this.$store.commit("SET_Menu", param);
      this.$store.commit("SET_scode", scode);
      
      if (one == -1) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({
          path: "/page",
          query: {
            mcode: nowMcode,
            one: one,
            tow: tow,
            three: subs ? 0 : three,
            scode: scode,
          },
        });
      }

      //隐藏策划导航栏
      let LeftSildeMenubar = document.querySelector(".menubar ul");
      LeftSildeMenubar.classList.remove("active");
      document.body.style.overflow = "scroll";
    },
  },
};
</script>
<style lang="less" scoped>
.subnav {
  display: none;
}
.nav-active .title {
  color: #b50003 !important;
  border-bottom: 2px solid #b50003 !important;
  box-sizing: border-box !important;
  transition: none !important;
}
.nav-logo {
  display: none;
  width: 30px;
  margin-top: 15px;
  vertical-align: middle;
  margin-left: 15px;
}
.xd-active {
  opacity: 1 !important;
  box-shadow: 0 0 6px #0d0d0dab;
}
.xys-info {
  display: none;
}
.content {
  width: 100%;
  height: 100%;
  text-align: center;
}

.search {
  display: flex;
  .box {
    border: 1px solid #ddd;
    height: 40px;
    padding: 0 12px;
    margin: 20px 0;
    display: flex;
    align-items: center;
    width: 440px;
    input {
      height: 38px;
      border: 0;
      outline: none;
      flex: 1;
      padding-left: 12px;
      font-size: 14px;
    }
  }

  .icon0 {
    margin: 31px 10px 31px 35px;
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
}

.menubar {
  width: 100%;
  top: 0;
  height: 80px;
  display: flex;
  flex-direction: row;
  user-select: none;
  z-index: 100;
  background-color: #fff;

  .logo {
    flex: 1;
    text-align: left;
    padding: 20px 0;
    cursor: pointer;
    img {
      height: 40px;
    }
  }
  .logotitle {
    width: 100%;
    line-height: 60px;
    font-size: 24px;
    color: #fff;
  }
  .user {
    width: 20%;
    min-width: 80px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-right: 30px;
    align-items: center;
    cursor: pointer;
    .userimg {
      width: 60px;
      height: 60px;
      img {
        width: 36px;
        height: 36px;
        margin-top: 12px;
        margin-right: 0px;
        border-radius: 50%;
      }
    }
    .username {
      font-size: 14px;
      color: #eee;
      height: 60px;
      line-height: 60px;
    }
  }
  .subnav {
    height: 0;
  }
  ul {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: left;
    text-align: center;
    li {
      min-width: 50px;
      list-style: none;
      margin-left: 35px;
      transition: all 0.2s ease;
      cursor: pointer;
      &:hover {
        .subnav {
          height: 60px;
        }
      }
      .subnav {
        position: fixed;
        overflow: hidden;
        height: 0;
        left: 0;
        top: 80px;
        width: 100%;
        line-height: 60px;
        transition: all 0.3s;
        background-color: rgba(0, 0, 0, 0.4);
        display: block;
        z-index: 9999;
        span {
          color: #fff;
          transition: all 0.3s;
          padding: 0 20px;
          font-size: 16px;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      a {
        position: relative;
        display: block;
        width: 100%;

        text-decoration: none;
        .more {
          display: none;
        }
        .title {
          position: relative;
          display: block;
          line-height: 80px;
          height: 80px;
          text-align: center;
          font-size: 18px;
          color: #444;
        }
      }
      a:hover span {
        transition: all 0.3s ease;
        color: #b50003;
      }
    }
  }
}

.list {
  margin-left: 5%;
  margin-right: 5%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: center;
  justify-content: space-around;
  align-items: center;
  .item {
    flex-basis: 23%;
    margin-top: 22px;
    height: 260px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    transition: 0.314s;
    cursor: pointer;
    .desc {
      width: 90%;
      margin: 16px;
      flex-basis: 80%;
      background-color: #f5f5f5;
    }
    .title {
      width: 90%;
      margin: auto 16px;
      margin-bottom: 16px;
      flex-basis: 20%;
      background-color: #f5f5f5;
    }
  }
  .item:hover {
    transform: scale(1.02);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  }
}

.footer {
  position: relative;
  bottom: 0;
  height: 172px;
  color: #a5a5a5;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  line-height: 36px;
}
@media (max-width: 1110px) {
  .menubar {
    .logo {
      padding: 25px 0;
      img {
        height: 30px;
      }
    }
    ul {
      .nav-active {
        border-bottom: 1px solid #b50003 !important;
      }
      li {
        margin-left: 25px;
        &:hover {
          .subnav {
            height: 50px;
          }
        }
        .subnav {
          line-height: 50px;
          span {
            padding: 0 20px;
            font-size: 14px;
          }
        }
        a {
          .title {
            font-size: 16px;
            font-weight: normal;
            border: none !important;
          }
        }
      }
    }
  }
}
/* 响应式 */
@media (max-width: 992px) {
  .search {
    overflow: hidden;
    height: 60px;
    .box {
      border: 1px solid #ddd;
      height: 30px;
      padding: 0 5px;
      margin: 15px 0;
      display: flex;
      align-items: center;
      width: 100%;
      img {
        display: none;
      }
      input {
        height: 28px;
        border: 0;
        outline: none;
        flex: 1;
        padding-left: 5px;
        font-size: 12px;
        width: 100%;
      }
    }

    .icon0 {
      margin: 22px 10px 22px 15px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
  .nav-logo {
    display: block;
  }
  .nav-active {
    color: white !important;
    font-weight: bold !important;
    border-bottom: none !important;
    box-sizing: border-box !important;
    height: 60px;
    transition: all 0.1s ease-in;
  }
  .xys-info {
    display: block;
    margin-top: 20px;
    color: #aaa;
    img {
      width: 60px;
      margin-bottom: 10px;
    }
    hr {
      width: 80%;
      margin-left: 10%;
      margin-top: 20px;
      margin-bottom: 20px;
      border: none;
      height: 2px;
      border-radius: 10rem;
      background: #ccc;
    }
    div {
      cursor: pointer;
    }
  }

  .subnav {
    height: 40px;
    overflow: hidden;
    display: block;
    .s {
      background-color: #fff;
      height: 60px;
      line-height: 40px;
      display: block;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      text-align: left;
      top: 60px;
      width: 100%;
      white-space: nowrap; /* ul中的内容不换行 */
      overflow-x: scroll; /* 横向滚动 */
      overflow-y: hidden; /* 禁止纵向滚动*/
      span {
        color: #000;
        font-size: 14px;
        font-weight: normal;
        padding: 0 15px;
        display: inline-block;
        cursor: pointer;
      }
      .active {
        color: #b50003;
      }
    }
  }
  .menubar {
    display: flex;
    align-items: center;
    height: 60px;
    transition: 0.321s;
    overflow: hidden;
    .logo {
      top: 0;
      padding: 19px 0;
      width: 100px;
      img {
        height: 22px;
      }
    }
    .logotitle {
      width: 100%;
      line-height: 60px;
      font-size: 20px;
      color: #fff;
    }

    ul {
      width: 0px;
      position: fixed;
      display: block !important;
      left: -60px;
      bottom: 0;
      display: flex;
      flex-direction: column;
      background-color: #000;
      overflow: hidden;
      z-index: 10;
      box-shadow: 6px 0px 10px 0px rgba(0, 0, 0, 0.3);
      transition: 0.3s;
      .subnav {
        display: none;
      }
      li {
        width: 100%;
        border-bottom: 1px solid #444;
        margin-left: 0;
        padding: 0 20px;

        &:hover {
          .subnav {
            height: 0 !important;
          }
        }
        a {
          display: flex;
          align-items: center;
          .more {
            width: 20px;
            height: 20px;
            display: block;
          }
          .title {
            position: relative;
            display: block;
            height: 60px;
            line-height: 60px;
            text-align: left;
            font-size: 14px;
            color: #fff;
            flex: 1;
          }
        }
      }
    }
    ul.active {
      left: 0;
      top: 0;
      width: 260px;
    }
    ul.active::after {
      content: "";
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.4);
      z-index: -1;
    }
    .bar {
      cursor: pointer;
      padding: 22px 0 22px 10px;
      img {
        width: 16px;
        margin: 0;
      }
    }
    .user .username {
      display: none;
    }
  }

  .list .item {
    flex-basis: 45%;
    margin-top: 12px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .list .item {
    flex-basis: 100%;
    margin-top: 12px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue